<template>
  <div class="supports col-md-12">

    <ListTickets
      :filter_asc="filter_asc"
      :filter_type="filter_type"
      :tickets="tickets"
      :show_new_ticket="false"
      @check_link="checker"
      @change_filter="change_filter"
      @change_list="change_list"
      @clear_list="clear_list"
    />

  </div>
</template>

<script>
import ShowTicket from './Supports/ShowTicket'
import ListTickets from './Supports/ListTickets'
export default {
  name: 'Supports',
  components: {
    ListTickets
  },

  data () {
    return {
      filter_type: 'status',
      filter_asc: 'asc',
      check_link: true,
      search_list: [],
      check_search: false
    }
  },

  activated () {
    if (this.$route.params.support_id){
      for (let ticket of this.$store.getters.getTicketList) {
        if (+ticket.id === +this.$route.params.support_id) {
          this.show_ticket(ticket.id, true)
        }
      }
    }
  },

  computed: {
    tickets () {
      if (this.check_search) {
        let search_list = this.search_list
        search_list.sort(this.compareNumbers)
        return search_list
      }
      else{
        let list = this.$store.getters.getTicketList
        if (list.length) {
          list.sort(this.compareNumbers)
        }

        return list
      }

    },
    ticket_status () {
      return this.$store.getters.getTicketStatus
    },
  },

  methods: {
    checker(){
      this.check_link = false
    },
    compareNumbers(a, b) {
      if (typeof(a[this.filter_type]) == 'string') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] < b[this.filter_type] ? 1 : -1;
        }else{
          return a[this.filter_type] > b[this.filter_type] ? 1 : -1;
        }
      }else if (typeof(a[this.filter_type]) == 'number') {
        if (this.filter_asc === 'asc') {
          return a[this.filter_type] - b[this.filter_type]
        }else{
          return b[this.filter_type] - a[this.filter_type]
        }
      }
    },
    change_filter(type){
      if (this.filter_type === type) {
        if (this.filter_asc === 'asc') {
          this.filter_asc = 'desc'
        }else{
          this.filter_asc = 'asc'
        }
      }else{
        this.filter_type = type
      }
    },

    change_list(data){
      this.check_search = true
      this.search_list = data
    },

    clear_list(){
      this.search_list = []
      this.check_search = false
      this.$store.dispatch('ticketList')
    },

    show_ticket(ticket_id, check = false){
      if (this.$route.name === 'supports' || this.$route.name === 'support_item') {
        this.check_link = false
        this.$http.v1.getTicketInfo(ticket_id, (response) => {
          let ticket_data = response.data
          let t = this.$createElement(ShowTicket, {
            props: { ticket: ticket_data, check: check }, on: {
              close: () => { this.$modal.hide('dynamic-modal') },
              reload: () => { this.$store.dispatch('ticketList') }
            }
          })
          let temp = {
            render() { return t }
          }
          this.$modal.show(temp, {}, { height: 'auto', name: 'dynamic-modal' })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .supports{
    height: 100%;
  }

  @media (max-width: 500px){
    .supports{
      padding: 0 5px;
    }
  }
</style>
